import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

const PlotAreaField: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <TextInput
      id='plot-area'
      propertyName='plotArea'
      placeholder=''
      label={<span>{t('wizard.screen.basicInfo.plotArea', 'Plot Area')}</span>}
      value={insertionData.plotArea}
      maxLength={11}
      type='text'
      affixRight='unit'
      unitRight='sqm'
      errors={validationMessages?.plotArea ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default PlotAreaField
